<div
	class="migrated-user-welcome-title"
	test-id="migrated-user-welcome-title"
	[innerHTML]="'migrated-user.welcome-title' | translate "
></div>

<img obgImageContentGroup="common" obgImageContent="common.welcome-flow-image" />

<p [innerHTML]="'migrated-user.welcome-description' | translate"></p>

<h4 [innerHTML]="'migrated-user.welcome-steps-title' | translate"></h4>
<ol>
	<li class="confirm-details" [innerHTML]="'migrated-user.welcome-step-confirm-details' | translate"></li>
	<li class="accept-tnc" [innerHTML]="'migrated-user.welcome-step-accept-tnc' | translate"></li>
	<li class="accept-privacy-policy" [innerHTML]="'migrated-user.accept-privacy-policy' | translate"></li>
</ol>

<button
	mat-flat-button
	color="accent"
	test-id="migrated-user-welcome-button"
	(click)="navigateToCompleteAccountLogin()"
	[innerHTML]="'general.continue' | translate"
></button>
